module.exports = __webpack_public_path__ + "static/img/M-6.c84c6fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/M-6.png
// module id = w75Z
// module chunks = 0